<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" :disabled="$hasExtraModule('equipment') != 'active'" />

        <action-button
          type="delete"
          @click="del(equipmentcategory.id)"
          v-if="equipmentcategory.id && $can('equipment-access') && modal != true"
          :disabled="$hasExtraModule('equipment') != 'active'"
        />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="equipmentcategory.name"
                  v-model="equipmentcategory.name"
                  v-validate="'max:50'"
                  :label="$t('equipmentcategories.name')"
                  :error-messages="errors.collect('equipmentcategory.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="equipmentcategory.status"
                  v-model="equipmentcategory.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="$dd_task_status()"
                  :label="$t('tasks.status')"
                  :error-messages="errors.collect('equipmentcategory.status')"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "EquipmentCategoriesForm",

  props: ["id", "modal"],

  data() {
    return {
      page_title: "",
      predata: {},
      equipmentcategory: {},
      dictionary: {
        attributes: {
          "equipmentcategory.name": this.$t("equipmentcategories.name"),
          "equipmentcategory.status": this.$t("equipmentcategories.status")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.$hasExtraModule("equipment") == "active") {
      this.$validator.validateAll().then(() => {
        this.$leaveFormConfirmation(next, this.equipmentcategory, this.predata, this.save, this.isFormValid)
      })
    } else {
      next()
    }
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      this.page_title = this.$t("equipmentcategories.new_title")
      this.equipmentcategory = {
        status: this.$getDefaultDropdown(this.$dd_task_status())
      }

      this.predata = JSON.parse(JSON.stringify(this.equipmentcategory))
    } else {
      axios
        .get(this.API_URL + "equipment-category/" + this.id)
        .then((res) => {
          this.equipmentcategory = res.data.data
          this.predata = JSON.parse(JSON.stringify(this.equipmentcategory))

          this.page_title = this.$t("equipmentcategories.edit_title", {
            name: this.equipmentcategory.name
          })
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.equipmentcategory.id) {
              // Create
              axios
                .post(this.API_URL + "equipment-category", {
                  name: this.equipmentcategory.name,
                  status: this.equipmentcategory.status,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.equipmentcategory = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.equipmentcategory))

                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "equipmentcategories",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.page_title = this.$t("equipmentcategories.edit_title", {
                          name: vm.equipmentcategory.name
                        })
                        vm.$router.replace(this.BACKEND_URL + `/equipment-categories/edit/${vm.equipmentcategory.id}`).catch(() => {})
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "equipment-category", {
                  id: this.equipmentcategory.id,
                  name: this.equipmentcategory.name,
                  status: this.equipmentcategory.status
                })
                .then((res) => {
                  vm.equipmentcategory = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.equipmentcategory))

                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "equipmentcategories",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "equipment-category/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/equipment-categories")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
